import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import MarcoMarca from './MarcoMarca';

// Elegir cómo armar la web: seguir en la charla o completar el formulario.
// No promete tiempos: lo que tarda depende de cada persona.
const WebStartChoice = () => {
  const { state } = useLocation();
  const navigate  = useNavigate();
  const nombre    = state?.businessName;

  return (
    <MarcoMarca pantalla="web-inicio">
      <div className="gh-panel gw-panel" data-fase="charla">
        <p className="gw-etiqueta">{nombre ? `Web para ${nombre}` : 'Tu web'}</p>
        <h1 className="gw-titulo">¿Cómo querés armarla?</h1>
        <div className="gh-opciones gw-opciones">
          <button type="button" className="gh-opcion" onClick={() => navigate('/web-chat', { state })}>
            <span className="gw-opcion__texto">
              <strong>Seguimos hablando</strong>
              <span>Te hago las preguntas y respondés.</span>
            </span>
          </button>
          <button type="button" className="gh-opcion" onClick={() => navigate('/dashboard', { state })}>
            <span className="gw-opcion__texto">
              <strong>Prefiero el formulario</strong>
              <span>Completás los campos y ves la web tomar forma.</span>
            </span>
          </button>
        </div>
        <p className="gw-nota">Podés cambiar de modo cuando quieras.</p>
      </div>
    </MarcoMarca>
  );
};

export default WebStartChoice;
